import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Container, Row, Col } from 'reactstrap';
import { isMobile } from 'react-device-detect';
import lodash from 'lodash';
import {
  getContactCompanyList,
  getOrgPaymentMethodList,
  handleCurrentStep,
  resetState,
  setProgressBarPercent,
  saveSelectedCustomers,
  saveNewSelectedPaymentMethod,
  validateHandler as validateEmail,
  changeHandler,
  updatePaymentMethod,
  creditCardValidation,
  resetDeptPaymentFlag,
  setMultiple,
  setForbidden,
  setSelectedCompanyId,
  setSelectedProvider,
  saveToHistory,
  clearHistory,
  setIsPrivateDefaultAreSelected,
  setBusinessBlockFlag,
  setPrivateUserUpdateObj,
  setCompletedFlag,
} from './updatePaymentMethodSlice';
import { resetState as resetBankState } from './BankPaymentMethod/bankPaymentSlice';
import { resetStore as resetPaymentState } from '../../../Components/Block/SaleBlock/Payment/PaymentSlice';
import { resetStore as resetPaymentCGState } from '../../../Components/Block/SaleBlock/PaymentCG/PaymentCGSlice';
import { showAppLoader, hideAppLoader } from '../../Shared/Loader/LoaderSlice';
import WelcomeToUpdatePaymentMethodComponent from './WelcomeToUpdatePaymentMethodComponent';
import SelectCompanyComponent from './SelectCompanyComponent';
import SelectCustomersComponent from './SelectCustomers/SelectCustomersComponent';
import NewPaymentMethodComponent from './SelectNewPaymentMethodComponent';
import UpdatePaymentProcessComponent from './NewPaymentInformation/UpdatePaymentProcessComponent';
import CompletedComponent from './CompletedComponent';
import ProgressBar from '../../Shared/ProgressBar/progressBar';
import Config from '../../../Config';
import gaParams from '../../../utilities/analytics/constants';
import { gaEvent } from '../../../utilities/analytics/tracking';
import useExtendedEffect from '../../../utilities/hooks/useExtendedEffect';
import useClearStateResetFlag from '../../../utilities/hooks/useClearStateResetFlag';
import { gaReportOnButtonClick, gaClickNumOfMethods } from './gaReports';
import { dwhUpdateFailed } from './dwhReports';

const UpdatePaymentMethod = (props) => {
  const { isLoading, selectedProvider, selectedForUpdate, newSelectedPaymentMethod } = props.data;
  console.log(props);

  useEffect(() => {
    if (props.data.isLoading && !props.loader.isLoading) {
      props.showAppLoader();
    } else {
      if (props.loader.isLoading) {
        setTimeout(() => {
          props.hideAppLoader();
        }, 300);
      }
    }
  }, [props.data.isLoading]);

  useEffect(() => {
    const isBusiness = props.cmsData?.isBusinessBlock?.value || false;
    const blockId = props.cmsData?.contentLink?.id;
    props.setBusinessBlockFlag({ isBusiness, blockId });
    //  reportGAPrivateFlow();
  }, []);

  useEffect(() => {
    if (props.paymentCg?.form?.errorObj != null) dwhUpdateFailed(!props.isPrivate, props?.paymentCg?.form?.errorObj?.errorId);
  }, [props.paymentCg.form]);

  useExtendedEffect((runSideEffects) => {
    if (typeof window.scrollTo === 'function') {
      window.scrollTo(0, 0);
    }

    return () => {
      if (!props.data.renderFromDeptPayment) {
        props.resetState();
        props.resetBankState();
        props.resetPaymentState();
        props.resetPaymentCGState();
        props.clearHistory();
      }
    };
  }, []);

  useExtendedEffect(
    (runSideEffects) => {
      async function load() {
        await props.getContactCompanyList();
      }
      if (runSideEffects) {
        if (props.data.isDeptPayment === false) {
          load();
        }
      }
    },
    [props.data.isDeptPayment]
  );

  useClearStateResetFlag();

  const backToLobby = async () => {
    if (props.data.isBusinessBlock) {
      let content = await props.context.loadContentByPath(Config.businessLobbyUrl);
      props.context.navigateTo(content);
    } else {
      let content = await props.context.loadContentByPath(Config.lobbyUrl);
      props.context.navigateTo(content);
    }
  };

  //step 2
  const setSelectedForUpdate = (idNumber, selectedProvider) => {
    if (idNumber != undefined && selectedProvider != undefined && props.data.isBusinessBlock) {
      const isPrivateUserFlow = props.data.isBusinessBlock ? false : props.data.isBusinessBlock;
      props.getOrgPaymentMethodList({ idNumber, selectedProvider, isPrivateUserFlow });
    }
  };

  //step 3
  const setSelectedCustomers = (dataWithSelectedCustomers) => {
    let selectedPayments = 0;
    let selectedInvoices = 0;
    dataWithSelectedCustomers.map((data) => {
      let selectedInvoicesCount = lodash.filter(data.customersList, function (customer) {
        return customer.checked == true;
      }).length;

      if (selectedInvoicesCount > 0) {
        ++selectedPayments;
        selectedInvoices += selectedInvoicesCount;
      }
    });
    if (props.data.isBusinessBlock) {
      gaReportOnButtonClick('all_payment_methods_continue_to_the_next_step_btn');
      gaClickNumOfMethods(selectedPayments);
    }

    props.saveSelectedCustomers({ dataWithSelectedCustomers, selectedPayments, selectedInvoices });
  };

  //step4
  const setNewSelectedPaymentMethod = (method) => {
    if (props.data.isBusinessBlock) {
      gaReportOnButtonClick('select_newPayment_method_continue_to_the_next_step_btn');
    }

    const gaParam = method == 'Bank' ? 'הוראת_קבע' : 'כרטיס_אשראי';
    gaEvent(
      gaParams.UPDATE_PAYMENT_METHOD_CLICK_CHOSEN_PAYMENTMETHOD.category,
      gaParams.UPDATE_PAYMENT_METHOD_CLICK_CHOSEN_PAYMENTMETHOD.eventType,
      gaParam
    );
    props.saveNewSelectedPaymentMethod(method);
  };
  //step 5
  const createAndSendPaymentData = async () => {
    if (!props.data.isBusinessBlock) {
      let selectedAccounts = [];
      selectedForUpdate.customersPaymentData.map((data) => {
        data.customersList.map((customer) => {
          if (customer.checked == true) {
            let elem = customer?.number ? customer?.number : customer?.id;
            selectedAccounts.push(elem);
          }
        });
      });

      //const splittedUserName = props.payment.form.userName.trim().split(' ');

      const privateReq = {
        Id: props.IdNumber,
        ConsumerId: props.IdNumber,
        PaymentMethodType: 'CC',
        BanOrPsid: 'Ban',
        PaymentType: 'UpdatePaymentMethod',
        CCToken: props.paymentCg.CCToken, //props.payment.CCData.CCToken
        CardYear: props.paymentCg.form.CardDueYear, //props.payment.CCData.CCDueYear
        CardMonth: props.paymentCg.form.CardDueMonth, //props.payment.CCData.CCDueMonth
        CardCvv: props.payment.form.CVV,
        CreditCardType: props.paymentCg.CCType, //props.payment.CCData.CCType
        CCFourLastNumbers:
          //props.payment.form.CardNumber.substring(props.payment.form.CardNumber.length - 4) ||
          props.paymentCg.Credit4Digits.substring(props.paymentCg.Credit4Digits.length - 4),
        //PaymentOwnerFirstName: splittedUserName[0],
        //PaymentOwnerLastName: splittedUserName.length == 1 || splittedUserName[1] == '' ? splittedUserName[0] : splittedUserName[1],
        PhoneNumber: props.mobile || props.data.contactPhoneNumber,
        OrgType: 'Cellcom',
        AccountList: selectedAccounts,
        EMail: props.data.form.email,
        PrivateUserIdNumber: props.paymentCg.form.id || props.IdNumber,
        AuthNo: props.paymentCg.CGData.authNumber,
      };
      props.updatePaymentMethod(privateReq);
      return;
    }

    let request;
    let selectedAccounts = [];
    selectedForUpdate.customersPaymentData.map((data) => {
      data.customersList.map((customer) => {
        if (customer.checked == true) {
          let elem = customer?.number ? customer?.number : customer?.id;
          selectedAccounts.push(elem);
        }
      });
    });

    const generalObj = {
      AccountList: selectedAccounts,
      BanOrPsid: selectedProvider.toLowerCase() === 'cellcom' ? 'Ban' : 'Psid',
      CCToken: null,
      CardYear: null,
      CardMonth: null,
      CardCvv: null,
      CreditCardType: 'UNKNOWN',
      CCFourLastNumbers: null,
      AuthNo: null,
      PaymentOwnerFirstName: '',
      PaymentOwnerLastName: '',
      ConsumerId: props.data.contactId,
      EMail: props.data.form.email,
      IdNumber: selectedForUpdate.idNumber,
      OrgType: selectedProvider,
      PaymentMethodType: newSelectedPaymentMethod,
      PaymentType: 'UpdatePaymentMethod',
      PhoneNumber: props.data.contactPhoneNumber,
      BankAccountFileGuid: null,
      IsBusiness: props.data.isBusinessBlock,
    };

    if (newSelectedPaymentMethod === 'CC') {
      request = getDataForCloudModeCreditCard(generalObj);
    } else {
      request = getDataForBankPayment(generalObj);
    }
    props.updatePaymentMethod(request);
  };

  const getDataForCreditCard = (generalObj) => {
    const splittedUserName = props.payment.form.userName.trim().split(' ');

    return {
      ...generalObj,
      PaymentOwnerFirstName: splittedUserName[0],
      PaymentOwnerLastName: splittedUserName.length == 1 || splittedUserName[1] == '' ? splittedUserName[0] : splittedUserName[1],
      CCToken: props.payment.CCData.CCToken,
      CardYear: props.payment.CCData.CCDueYear,
      CardMonth: props.payment.CCData.CCDueMonth,
      CardCvv: props.payment.form.CVV,
      CreditCardType: props.payment.CCData.CCType,
      CCFourLastNumbers: props.payment.form.CardNumber.substring(props.payment.form.CardNumber.length - 4),
    };
  };

  const getDataForCloudModeCreditCard = (generalObj) => {
    return {
      ...generalObj,
      CCToken: props.paymentCg.CCToken,
      CardYear: props.paymentCg.form.CardDueYear,
      CardMonth: props.paymentCg.form.CardDueMonth,
      CreditCardType: props.paymentCg.CCType,
      CCFourLastNumbers: props.paymentCg.Credit4Digits.substring(props.paymentCg.Credit4Digits.length - 4),
      AuthNo: props.paymentCg.CGData.authNumber,
    };
  };

  const getDataForBankPayment = (generalObj) => {
    return { ...generalObj, BankAccountFileGuid: props.bankPayment.form.validatedFileName };
  };

  const isSinglePayingMethod = (generalObj) => {
    return props.AccountList.selectedAccounts.PayingMethodAccounts.length > 1 ? true : false
  }

  return (
    <>
      <ProgressBar points={props.data.progressBarPoints} percent={props.data.progressBarPercent} />
      <div
        className={`${!props.data.isBusinessBlock && props.data.onlyPSIDAccounts ? 'onlyPSIDAccounts' : ''
          }update-payment-method-container ${isLoading ? 'isLoading' : ''} ${!props.data.isBusinessBlock ? 'payment-private-flow' : ''
          }`}>
        
              <WelcomeToUpdatePaymentMethodComponent
                props={props}
                backToLobby={backToLobby}
                setSelectedForUpdate={(idNumber, selectedProvider) => setSelectedForUpdate(idNumber, selectedProvider)}
              />
              <SelectCompanyComponent
                props={props}
                setSelectedForUpdate={(idNumber, selectedProvider) => setSelectedForUpdate(idNumber, selectedProvider)}
                backToLobby={backToLobby}
              />
              <SelectCustomersComponent
                props={props}
                setSelectedCustomers={(data) => setSelectedCustomers(data)}
                backToLobby={backToLobby}
                setIsPrivateDefaultAreSelected={setIsPrivateDefaultAreSelected}
              />

              <NewPaymentMethodComponent
                props={props}
                setNewSelectedPaymentMethod={setNewSelectedPaymentMethod}
                resetDeptPaymentFlag={props.resetDeptPaymentFlag}
              />

              <UpdatePaymentProcessComponent
                props={props}
                createAndSendPaymentData={createAndSendPaymentData}
                changeHandler={props.changeHandler}
                validateEmail={props.validateEmail}
                creditCardValidation={creditCardValidation}
                resetPaymentCGState={props.resetPaymentCGState}
                setPrivateUserUpdateObj={props.setPrivateUserUpdateObj}
                setCompletedFlag={props.setCompletedFlag}
                isAllowedOtherPayment={props.cmsData.isAllowedOtherPayment}
              />
              <CompletedComponent props={props} backToLobby={backToLobby} context={props.context} />
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    data: state.updatePayment,
    payment: state.Payment,
    paymentCg: state.PaymentCG,
    bankPayment: state.BankPayment,
    selectedFromPortal: state.portalsBlock.selectedHetPay,
    loader: state.loader,
    userBanPsids: state.updatePayment.userBanPsids,
    IdNumber: state.authentication.loginData.userDetails.IDNumber,
    mobile: state.authentication.loginData.userDetails.contactNumber,
    isPrivate: state.authentication.loginData.userDetails.isPrivate,
    privateUserUpdateResultObj: state.updatePayment.privateUserUpdateResultObj,
  };
};

const mapDispatchToProps = {
  getContactCompanyList,
  getOrgPaymentMethodList,
  setBusinessBlockFlag,
  handleCurrentStep,
  resetState,
  setProgressBarPercent,
  saveSelectedCustomers,
  saveNewSelectedPaymentMethod,
  validateEmail,
  changeHandler,
  updatePaymentMethod,
  creditCardValidation,
  resetBankState,
  resetPaymentState,
  resetPaymentCGState,
  resetDeptPaymentFlag,
  setMultiple,
  setForbidden,
  setSelectedCompanyId,
  setSelectedProvider,
  clearHistory,
  saveToHistory,
  setIsPrivateDefaultAreSelected,
  //loader
  showAppLoader,
  hideAppLoader,
  setPrivateUserUpdateObj,
  setCompletedFlag,
};

export default connect(mapStateToProps, mapDispatchToProps)(UpdatePaymentMethod);
